import { branch, renderComponent } from 'recompact';

import { Progress } from 'src/app/components/Elements';

/**
 * This is a HoC that allows a component to swap between a loading state and a rendered state.
 *
 * It relies on the `isLoading` property to control it.
 *
 * Note: this will unmount the composed component,
 * so it is intended to wrap the presentational ("dumb") component, not the container
 *
 * Example:
 *
 * index.js:
 *   class Component { ... }
 *   Component.propTypes = {
 *     isLoading: PropTypes.bool.isRequired,
 *     ...
 *   }
 *   export default compose(withLoading)(Component);
 *
 * @param {Element | Function} BaseComponent
 * @param {Element?} WrapperComponent
 * @returns {HoC}
 */
export const withLoading = (BaseComponent, WrapperComponent) => {
  return branch(
    props => props.isLoading,
    renderComponent(() =>
      WrapperComponent ? (
        <WrapperComponent>
          <div className="text-secondary text-center">
            <Progress color="inherit" />
          </div>
        </WrapperComponent>
      ) : (
        <div className="text-secondary text-center">
          <Progress color="inherit" />
        </div>
      )
    )
  )(BaseComponent);
};
